import React from 'react'
import Top from "../assets/images/top.webp"
import Bg from "../assets/images/bg.webp"
import Bg1 from "../assets/images/bg1.webp"
import Eth1 from "../assets/images/eth1.webp"
import Eth2 from "../assets/images/eth2.webp"
import Eth3 from "../assets/images/eth3.webp"
import Eth4 from "../assets/images/eth4.webp"
import meowth from "../assets/images/meowth.webp"
import head from "../assets/images/head.webp"
import dextools from "../assets/images/dextools.svg"
import dexscreener from "../assets/images/dexscreener.svg"

const Home = () => {
  return (
    <>
      <h1 className="font-primary font-black fixed top-5 left-5 font-bold text-2xl z-20">meowth | ニャース</h1>
      <section className="w-full min-h-screen h-auto relative">
        <img src={Top} className="absolute bottom-0 w-full" alt="Top"/>
        <img src={Bg} class="w-full h-screen absolute object-cover z-[-2]" alt="bg"/>
        <img src={Bg1} class="w-full min-h-screen fixed object-cover z-[-3]" alt="bg1"/>
        <div>
          <img src={Eth1} className="absolute w-1/3" alt=""/>
        </div>
        <div>
          <img src={Eth2} className="w-1/5 absolute right-5" alt=""/>
        </div>
        <img src={Eth3} className="w-1/3 absolute right-3 bottom-0" alt=""/>
        <img src={Eth4} className="w-1/3 absolute left-10 bottom-0" alt=""/>
        <div className="my-container flex flex-col items-center justify-center h-auto min-h-screen">
          <div >
            <img src={meowth} className="w-fit mx-auto"/>
          </div>
            <img src={head} className="w-1/2 absolute z-[-1]"/>
            <div className="">
              <ul className="flex gap-x-5 items-center justify-center xl:justify-start mt-5 mx-auto w-full">
                <a href="https://t.me/#">
                  <li className="rounded-full border-blue-500 text-blue-400 bg-primary [box-shadow:3px_3px_0px_#2b2929] bg-blue-700 p-3 text-white transition-all duration-300 ease-in-out hover:scale-[1.1] md:text-xl border-2">
                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"></path></svg>
                  </li>
                </a>
                <a href="https://x.com/#">
                  <li className="rounded-full border-blue-500 text-blue-400 bg-primary [box-shadow:3px_3px_0px_#2b2929] bg-blue-700 p-3 text-white transition-all duration-300 ease-in-out hover:scale-[1.1] md:text-xl border-2">
                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M18.2048 2.25H21.5128L14.2858 10.51L22.7878 21.75H16.1308L10.9168 14.933L4.95084 21.75H1.64084L9.37084 12.915L1.21484 2.25H8.04084L12.7538 8.481L18.2048 2.25ZM17.0438 19.77H18.8768L7.04484 4.126H5.07784L17.0438 19.77Z"></path></svg>
                  </li>
                </a>
                <a href="https://x.com/#">
                  <li className="rounded-full border-blue-500 text-blue-400 bg-primary [box-shadow:3px_3px_0px_#2b2929] bg-blue-700 p-3 text-white transition-all duration-300 ease-in-out hover:scale-[1.1] md:text-xl border-2">
                    <img src={dextools} className="w-4 h-4 lg:w-5 lg:h-5" alt="Dextools"/>
                  </li>
                </a>
                <a href="https://x.com/#">
                  <li className="rounded-full border-blue-500 text-blue-400 bg-primary [box-shadow:3px_3px_0px_#2b2929] bg-blue-700 p-3 text-white transition-all duration-300 ease-in-out hover:scale-[1.1] md:text-xl border-2">
                    <img src={dexscreener} alt="DexScreener" className="w-4 h-4 lg:w-5 lg:h-5"/>
                  </li>
                </a>
              </ul>
            </div>
        </div>
      </section>
    </>
  )
}

export default Home